export const setKillmail = 'setKillmail';
export const setPayoutData = 'setPayoutData';
export const attackersUpdated = 'attackersUpdated';
export const refreshPayoutData = 'refreshPayoutData';
export const storeSplits = 'storeSplits';
export const addSplitMutation = 'addSplit';
export const removeSplitMutation = 'removeSplit';
